// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify-extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify-extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._u-0 {\n  position: relative;\n  top: 24px;\n  right: 8px;\n  justify-content: flex-end;\n  z-index: 5;\n}\n\n@media screen and (max-width: 767px) {\n  ._u-0 {\n    top: 16px;\n    right: 4px;\n  }\n}\n", ""]);
// Exports
export var closeButton = "_u-0";
export default ___CSS_LOADER_EXPORT___;
